import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ModalModule } from '@vsolv/ui-kit/modal';
import { NgPipesModule } from 'ngx-pipes';

@NgModule({
  imports: [CommonModule, NgPipesModule, ModalModule],
  exports: [],
  declarations: [],
})
export class WarrantyCoverageModule {}
